export default __webpack_public_path__ + "static/media/bfcTransportation.bfcee05d.svg";